class RelatedProductsCarousel {
  constructor(root) {
    this.root = root;
    this.viewport = root.querySelector('.related-products__viewport');
    this.prev = root.querySelector('.related-products__nav--prev');
    this.next = root.querySelector('.related-products__nav--next');
    this.step = 250;
    this.onPrev = () => this.scrollByStep(-1);
    this.onNext = () => this.scrollByStep(1);
    this.onScroll = () => this.updateButtons();
    this.init();
  }

  init() {
    if (!this.viewport || !this.prev || !this.next) return;

    this.prev.addEventListener('click', this.onPrev);
    this.next.addEventListener('click', this.onNext);
    this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll);
    this.updateButtons();
  }

  scrollByStep(direction) {
    this.viewport.scrollBy({ left: direction * this.step, behavior: 'smooth' });
  }

  updateButtons() {
    const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
    this.prev.disabled = this.viewport.scrollLeft <= 1;
    this.next.disabled = this.viewport.scrollLeft >= maxScroll - 1;
  }
}

function refreshJudgeMeBadges() {
  if (window.jdgm?.customizeBadges) {
    window.jdgm.customizeBadges();
  } else if (window.jdgm?.reloadAllWidgets) {
    window.jdgm.reloadAllWidgets();
  }
}

function initRelatedCarousels(scope = document) {
  scope.querySelectorAll('[data-related-carousel]:not([data-carousel-ready])').forEach((root) => {
    root.dataset.carouselReady = 'true';
    new RelatedProductsCarousel(root);
  });
  refreshJudgeMeBadges();
}

document.addEventListener('DOMContentLoaded', () => initRelatedCarousels());

document.querySelectorAll('product-recommendations').forEach((node) => {
  const observer = new MutationObserver(() => {
    node.querySelectorAll('[data-related-carousel][data-carousel-ready]').forEach((root) => {
      delete root.dataset.carouselReady;
    });
    initRelatedCarousels(node);
  });
  observer.observe(node, { childList: true, subtree: true });
});
